import React from 'react'
import clsx from 'clsx'

export const Step4 = ({ otherClasses, handleChange, errorMessage }) => {
  const step4Classes = clsx(
    otherClasses,
    'px-6 lg:px-[40px] py-6 lg:py-[40px] '
  )

  return (
    <div className={step4Classes} data-testid="step4">
      <div className=" flex flex-col gap-6 w-full ">
        <label
          htmlFor="Notes"
          className="font-work-sans text-[14px] lg:text-[16px] font-semibold  text-primary_heading_color  leading-[24px]"
        >
          Notes
        </label>
        <textarea
          type="text"
          // placeholder="Enter Notes"
          onChange={handleChange}
          name="notes"
          required={false}
          id="notes"
          className={
            errorMessage?.notes
              ? 'px-4 py-[13px] w-full placeholder:font-work-sans  placeholder:text-[20px] placeholder:leading-[30px] placeholder:font-normal   border-[#ff4444] rounded-[24px] min-h-[320px] max-h-[320px] mt-2 placeholder:text-[#ff4444] hover:bg-primary_blue_50 text-[20px] leading-[30px] font-normal font-work-sans text-[#ff4444] focus:outline-[2px] active:border-[1px] active:outline-0 caret-[#2D7CF1] active:border-[#ff4444] focus:border-transparent focus:outline focus:outline-[#ff4444] border-[1px]'
              : 'px-4 py-[13px] w-full placeholder:font-work-sans  placeholder:text-[20px] placeholder:leading-[30px] placeholder:font-normal   border-gray-500 rounded-[24px] min-h-[320px] max-h-[320px] mt-2 placeholder:text-primary_heading_color hover:bg-primary_blue_50 text-[20px] leading-[30px] font-normal font-work-sans text-primary_heading_color focus:outline-[2px] active:border-[1px] active:outline-0 caret-[#2D7CF1] active:border-gray-500 focus:border-transparent focus:outline focus:outline-primary_dark_blue_500 border-[1px]'
          }
        ></textarea>
      </div>
    </div>
  )
}

export default Step4
